module.exports = __webpack_public_path__ + "static/media/mock-qr-evaluator.3a903b55.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/mock-demo/mock-qr-evaluator.png
// module id = 461
// module chunks = 0